import type { RouteRecordRaw } from 'vue-router';
import { IP_ROUTE_NAMES } from './ip-route-names';

export const ipRouterList: RouteRecordRaw[] = [
    {
        path: '/ip',
        redirect: '/ip/home',
        meta: { isIpModule: true },
    },
    {
        path: '/ip/legacy',
        name: IP_ROUTE_NAMES.IP_LEGACY,
        component: () => import('@/pages/home/IP.vue'),
    },
    {
        path: '/ip/home',
        name: IP_ROUTE_NAMES.IP_HOME,
        component: () => import('@/pages/ip/IpHome.vue'),
        meta: { isIpModule: true },
    },
    {
        path: '/ip/pricing',
        name: IP_ROUTE_NAMES.IP_PRICING,
        component: () => import('@/pages/ip/IpPricing.vue'),
        meta: { isIpModule: true },
    },
    {
        name: IP_ROUTE_NAMES.AI_DRAFTING,
        path: '/ip/:taskName/:taskId',
        props: (route) => ({
            taskName: route.params.taskName,
            taskId: route.params.taskId,
        }),
        component: () => import('@/pages/ip/AiDrafting.vue'),
        meta: { isIpModule: true },
    },
    {
        path: '/ai-drafting/:taskName/:taskId',
        redirect: to => ({
            name: IP_ROUTE_NAMES.AI_DRAFTING,
            params: {
                taskName: to.params.taskName as string,
                taskId: to.params.taskId as string,
            },
        }),
        meta: { isIpModule: true },
    }
]
